import { render, staticRenderFns } from "./CartSupItem.vue?vue&type=template&id=1f768f59&scoped=true&"
import script from "./CartSupItem.vue?vue&type=script&lang=ts&"
export * from "./CartSupItem.vue?vue&type=script&lang=ts&"
import style0 from "./CartSupItem.vue?vue&type=style&index=0&id=1f768f59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f768f59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
